import api from 'src/api';
export const getSessionList = async (filter) => {
  const response = await api(`/lms/mysession${filter}`, null, 'get');
  return response;
};
export const updateSession = (id,payload) => {
  return api(`/lms/session/${id}`, payload, 'put');
};
